export { default as PickTicketNewFlowDetailListTemplate } from './PickTicketNewFlowDetailListTemplate';
